export const getNameAbbreviation = (name: string) =>
  name
    .split(' ')
    .map(part => part.slice(0, 1).toUpperCase())
    .join('')
